import { render, staticRenderFns } from "./TicketCommentArsip.vue?vue&type=template&id=053418ad&scoped=true"
import script from "./TicketCommentArsip.vue?vue&type=script&lang=js"
export * from "./TicketCommentArsip.vue?vue&type=script&lang=js"
import style0 from "./TicketCommentArsip.vue?vue&type=style&index=0&id=053418ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053418ad",
  null
  
)

export default component.exports